import { PaymentMethodBenefits, useCheckoutContext } from '@zooplus/checkout-state';
import { CheckCircle } from '@zooplus/icons';
import { H4, P1 } from '@zooplus/ui-components';

import { useTranslation } from '@hooks/use-translations';
import { CHECKOUT_STATE_PROJECT_ID } from '@utilities/constants';

import styles from './login-benefits-section.module.scss';

const LoginBenefitsSection = () => {
  const { t } = useTranslation();

  const { checkoutState } = useCheckoutContext(CHECKOUT_STATE_PROJECT_ID);

  const benefitsKeys = checkoutState?.stateAttributes?.registrationBenefits;

  const getPaymentBenefitText = (paymentBenefits: PaymentMethodBenefits) => {
    const paymentMethodsNotAllowedForGuests = paymentBenefits.paymentMethodsNotAllowedForGuests;

    return paymentMethodsNotAllowedForGuests?.length
      ? [
          t(paymentBenefits.paymentMethodBenefitMessageKey, {
            0: paymentMethodsNotAllowedForGuests
              .map((paymentMethod: string) => {
                return t(paymentMethod);
              })
              .join(', '),
          }).replace(/, ([^,]*)$/, ` ${t('register.payment.methods.separator')} $1`),
        ]
      : [];
  };

  const benefits = benefitsKeys && [
    t(benefitsKeys.newCustomerDiscountMessageKey),
    t(benefitsKeys.rewardProgramMessageKey),
    ...getPaymentBenefitText(benefitsKeys.paymentMethodBenefits),

    t(benefitsKeys.reorderBenefitMessageKey),
    t(benefitsKeys.autoshipmentBenefitMessageKey),
  ];

  return (
    <article className={styles.loginBenefitsSection}>
      <H4 data-testid="benefits-title">{t('checkout.registration.benefits.title')}</H4>
      <ul className={styles.benefitsWrapper} data-testid="benefits-container">
        {benefits?.map((benefit, index) => (
          <li key={index.toString()} className={styles.benefitBox}>
            <CheckCircle />
            <div className={styles.benefitText}>
              <P1>{benefit}</P1>
            </div>
          </li>
        ))}
      </ul>
    </article>
  );
};

export default LoginBenefitsSection;
